import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { MenuList, Typography } from '@mui/material';
import React, { Children } from 'react';
import { MenuItem } from './MenuItem';
import { HelixStyles, HelixPalette } from '../../helix';
/**
 * Menu.ItemGroup component - groups related menu items
 */
export const MenuItemGroup = ({ dataId, style, children, title }) => {
    // Filter children to ensure they are MenuItem components
    const validChildren = Children.toArray(children).filter((child) => React.isValidElement(child) && child.type === MenuItem);
    if (validChildren.length === 0) {
        console.warn('Menu.ItemGroup should contain Menu.Item components');
        return null;
    }
    return (_jsxs(_Fragment, { children: [title && (_jsx(Typography, Object.assign({ "data-id": `${dataId}-title-label`, style: Object.assign(Object.assign({}, HelixStyles.style_03), { color: HelixPalette.neutral90, marginBottom: '8px', paddingLeft: '8px' }) }, { children: title }))), _jsx(MenuList, Object.assign({ "data-id": dataId, style: Object.assign({ padding: '0px' }, style) }, { children: validChildren }))] }));
};
